export default __webpack_public_path__ + "static/media/norrsken.3be31e31.png";